import apiClient from './client'
import type { MachineWithMetrics, MetricsHistory, NetworkHistoryEntry, AudioHistoryEntry, AudioMetricsHistory, AudioDeviceChange, BatteryHistoryEntry } from '@/types'

export async function getMachinesWithMetrics(): Promise<MachineWithMetrics[]> {
  const response = await apiClient.get<MachineWithMetrics[]>('/machines/with-metrics/')
  return response.data
}

export async function getMachine(machineId: string): Promise<MachineWithMetrics> {
  const response = await apiClient.get<MachineWithMetrics>(`/machines/${machineId}`)
  return response.data
}

export async function getMachineMetricsHistory(
  machineId: string,
  period: '4h' | '24h' | '7d' | '30d' = '24h'
): Promise<MetricsHistory[]> {
  const response = await apiClient.get<MetricsHistory[]>(`/machines/${machineId}/metrics/history`, {
    params: { period }
  })
  return response.data
}

export async function getNetworkHistory(machineId: string): Promise<NetworkHistoryEntry[]> {
  const response = await apiClient.get<NetworkHistoryEntry[]>(`/machines/${machineId}/network/history`)
  return response.data
}

export async function getAudioHistory(machineId: string): Promise<AudioHistoryEntry[]> {
  const response = await apiClient.get<AudioHistoryEntry[]>(`/machines/${machineId}/audio/history`)
  return response.data
}

export async function getBatteryHistory(machineId: string): Promise<BatteryHistoryEntry[]> {
  const response = await apiClient.get<BatteryHistoryEntry[]>(`/machines/${machineId}/battery/history`)
  return response.data
}

export async function getAudioMetricsHistory(
  machineId: string,
  period: '4h' | '24h' | '7d' | '30d' = '24h'
): Promise<AudioMetricsHistory[]> {
  const response = await apiClient.get<AudioMetricsHistory[]>(`/machines/${machineId}/audio/metrics/history`, {
    params: { period }
  })
  return response.data
}

export async function getAudioDevicesHistory(machineId: string): Promise<AudioDeviceChange[]> {
  const response = await apiClient.get<AudioDeviceChange[]>(`/machines/${machineId}/audio/devices/history`)
  return response.data
}
